import { render, staticRenderFns } from "./RipaEditStopExplanation.vue?vue&type=template&id=1a4a7066"
import script from "./RipaEditStopExplanation.vue?vue&type=script&lang=js"
export * from "./RipaEditStopExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports